<template>
  <span v-if="data?.video_url">
    <van-icon :name="$publicPath('/images/play.png')" size="20" @click="onShowVideo"/>
  </span>
</template>

<script setup>
import {TRACKERS, EVENTS} from "@/constants/events";
import {track} from "@/composables/useTrackEvent";

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const {emit: onOpenVideo} = useEventBus(EVENTS.PDP_VIDEO);

const onShowVideo = () => {
  onOpenVideo()
  track(TRACKERS.PLAY_ITEM_VIDEO, props.data)
}
</script>